
import { Inject, Pipe, PipeTransform, DOCUMENT } from '@angular/core';
import { ContactCardFragment } from 'src/app/api';
import { ConfigService } from 'src/app/config.service';
import { UrlService } from 'src/app/services/url.service';

@Pipe({
    name: 'contactCardUrl'
})
export class ContactCardUrlPipe implements PipeTransform {

  constructor(
    private configService: ConfigService,
    private urlService: UrlService
  ) {

  }

  transform(value: number | null, tripId?: number | null, selectedTab?: ContactCardFragment): string {
    

    return this.urlService.getContactCardUrl(value, {tripId, selectedTab})

   
  }

}
